const modalEditPhotoFormCompany = {
  title: 'Editar logo da Empresa',
  typographyTrue: 'Cadastro de Nova Empresa',
  typographyFalse: 'Infos da Empresa'
};

export default modalEditPhotoFormCompany;
